// This icon file is generated automatically.
var PLeftSquareOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M4.7 7.1l3.85 2.78c.08.06.2 0 .2-.1v-.73a.5.5 0 00-.2-.4L6.26 7l2.27-1.64a.5.5 0 00.21-.4v-.74c0-.1-.12-.16-.2-.1L4.71 6.9a.13.13 0 000 .2z" } }, { "tag": "path", "attrs": { "d": "M12.75.75H1.25a.5.5 0 00-.5.5v11.5c0 .28.22.5.5.5h11.5a.5.5 0 00.5-.5V1.25a.5.5 0 00-.5-.5zm-.63 11.38H1.88V1.87h10.25v10.25z" } }] }] }, "name": "p-left-square", "theme": "outlined" };
export default PLeftSquareOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PLeftSquareOutlined.js
// module id = 3487
// module chunks = 0